module.exports = __webpack_public_path__ + "img/home-banner.98862254.png";